<template>
    <div class="m-viewport" ref="view" v-if="ready">
        <div class="shop-main-view">
            <!-- <div class="m-user"><user-info/></div> -->
            <transition name="fade" mode="out-in" appear>
                <router-view v-if="isRouterAlive"></router-view>
            </transition>
        </div>
       
        <div class="shop-nav" :class="{'ios' : $global.isIos , 'kd' : KD.isApp()}">
          <router-link 
          v-for="(item,index) in router_mainfest" 
          :key = index
          v-bind:to="item.link" 
          class="u-nav"
          :class="item.name" 
          active-class="active">
          {{item.title}}
          </router-link>         
        </div>

        <loading v-show="Loading"/>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import loading from '@/components/loading.vue'
import KD from '@/assets/js/kd.js';

export default {
    data() {
        return {
            isRouterAlive : true,
            router_mainfest : [
                {name : 'shop',title : '集市',link : '/index'},
                {name : 'w12',title : '双12专享',link : '/w12'}, 
                {name : 'basket',title : '金算盘',link : '/basket'},
                {name : 'order',title : '账簿',link : '/order'}, 
                {name : 'task',title : '领福利',link : '/task'},                                           
                {name : 'ex',title : '积分商城',link : '/ex'},
            ],
            loadingCount: 0,
            loading : false,
            KD,
        }
    },
    components: {
        loading,
    },       
    provide () {
        return {
            reload: this.reload
        }
    },
    computed : {
        ...mapState(['Loading'])
    },        
    props : {
        ready : {
            default : false,
        },
    },
    methods: {
        async reload () {
            this.isRouterAlive = false
            await this.$nextTick(function () {
                this.isRouterAlive = true
            })
        },
        addLoading() {
            this.loading = true
            this.loadingCount++
        },        
        isCloseLoading() {
            this.loadingCount--
            if (this.loadingCount == 0) {
                this.loading = false
            }
        },
        destoryLoading(){
            this.loading = false
            this.loadingCount = 0            
        },       
    }        
}
</script>

<style lang="scss" scoped>
.m-viewport{
    position: relative;
    width: 750px;
    min-height: 100vh;
    margin: 0 auto 0;
    background-repeat: no-repeat;
    background-position: top center;
    box-sizing: border-box;
    font-size: 24px;
    background-color: #341e0d;
    color: #fff;
    overflow-x: hidden;
    /* overflow-y: scroll;    */
    background-image: url(~@/assets/images/cover.jpg);
    background-repeat: no-repeat;
    background-position: top center;
}

.m-viewport::after{
    content: '';
    display: block;
    position: absolute;
    top: 475px;
    left: 50%;
    width: 663px;
    height: 59px;
    transform: translateX(-50%);
    background-image: url(~@/assets/images/active-time.png);
}

.shop-main-view{
    position: relative;
    z-index: 2;
}

.shop-view{
    padding-bottom: 250px;
}

/* nav */
.shop-nav {
    display: flex;
    position: fixed;
    left: 50%;
    bottom: 0;
    z-index: 4;
    transform: translateX(-50%);    
    width: 750px;
    height: 130px;
    padding: 0 10px 8px;
    justify-content: space-between;
    align-items: flex-end;
    background-image: url(~@/assets/images/bg-nav.png);
    box-sizing: border-box;

    &.ios.kd{
        bottom: 40px;
    }

}

.pc .shop-nav{
    margin-left: -7px;
}

.shop-nav .u-nav {
    width: 117px;
    height: 72px;
    color: transparent;
    font-size: 0;
    background-repeat: no-repeat;
    background-position: center;
}

/* TODO */
.shop-nav .shop {
    background-image: url(~@/assets/images/nav/w12/1.png);
}

.shop-nav .shop.active {
    background-image: url(~@/assets/images/nav/w12/1D.png);
}

.shop-nav .w12 {
    background-image: url(~@/assets/images/nav/w12/2.png);
}

.shop-nav .w12.active {
    background-image: url(~@/assets/images/nav/w12/2D.png);
}

.shop-nav .task {
    background-image: url(~@/assets/images/nav/w12/5.png);
}

.shop-nav .task.active {
    background-image: url(~@/assets/images/nav/w12/5D.png);
}

.shop-nav .basket {
    background-image: url(~@/assets/images/nav/w12/3.png);
}

.shop-nav .basket.active {
    background-image: url(~@/assets/images/nav/w12/3D.png);
}

.shop-nav .order {
    background-image: url(~@/assets/images/nav/w12/4.png);
}

.shop-nav .order.active {
    background-image: url(~@/assets/images/nav/w12/4D.png);
}

.shop-nav .ex {
    background-image: url(~@/assets/images/nav/w12/6.png);
}

.shop-nav .ex.active {
    background-image: url(~@/assets/images/nav/w12/6D.png);
}

// .shop-nav .u-nav {
//     width: 148px;
//     height: 72px;
//     color: transparent;
//     font-size: 0;
//     background-image: url(~@/assets/images/nav/nav-1.png);
// }

// /* TODO */
// .shop-nav .shop {
//     background-image: url(~@/assets/images/nav/nav-1.png);
// }

// .shop-nav .shop.active {
//     background-image: url(~@/assets/images/nav/nav-1-act.png);
// }

// .shop-nav .task.active {
//     background-image: url(~@/assets/images/nav/nav-4-act.png);
// }

// .shop-nav .task {
//     background-image: url(~@/assets/images/nav/nav-4.png);
// }

// .shop-nav .basket.active {
//     background-image: url(~@/assets/images/nav/nav-2-act.png);
// }

// .shop-nav .basket {
//     background-image: url(~@/assets/images/nav/nav-2.png);
// }

// .shop-nav .order.active {
//     background-image: url(~@/assets/images/nav/nav-3-act.png);
// }

// .shop-nav .order {
//     background-image: url(~@/assets/images/nav/nav-3.png);
// }

// .shop-nav .ex.active {
//     background-image: url(~@/assets/images/nav/nav-5-act.png);
// }

// .shop-nav .ex {
//     background-image: url(~@/assets/images/nav/nav-5.png);
// }

.m-user{
    width: 750px;
    height: 48px;
    line-height: 48px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-userinfo.png);
}
</style>